export default "__VITE_ASSET__9d3c108f__"